
import { Vue, Component, Prop } from 'vue-property-decorator';
import ProjectCard from '@/components/projects/ProjectCardNew.vue';
import { Project, User } from '@/generated/graphql';
import ElementsSizeProvider from '@/components/uiSize/ElementsSizeProvider.vue';
import CardsContainerManager from '@/components/card/cardsContainerDeatils.vue';

@Component({
	components: {
		ElementsSizeProvider,
		CardsContainerManager,
		ProjectCard,
	},
})
export default class ProjectCollectionManager extends Vue {
	@Prop({ type: Array, required: true }) readonly projects!: Project[];
	@Prop({ type: Object, required: true }) readonly currentUser!: User;
	@Prop({ type: String, required: true }) readonly companyId!: string;
	@Prop({ type: Boolean, default: false }) readonly hideManager!: boolean;

	get completedProjects(): Project[] {
		return this.projects.filter(
			(project) => project.completed && !project.drafted
		);
	}
	get activeProjects(): Project[] {
		return this.projects.filter(
			(project) => !project.completed && !project.drafted
		);
	}

	get draftsProjects(): Project[] {
		return this.projects.filter(
			(project) => !project.completed && project.drafted
		);
	}
}
